import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/BMWGroup_BMW_MINI_Grey-Colour_RGB.png'
import _imports_1 from '@/assets/img/example_chart.png'


const _hoisted_1 = { class: "monthly-report-content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _cache[5] || (_cache[5] = _createElementVNode("img", {
        src: _imports_0,
        width: "500",
        height: "79",
        alt: "BMW logo"
      }, null, -1)),
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "Recipient: FIRST NAME LAST NAME", -1)),
        _createElementVNode("p", null, [
          _cache[0] || (_cache[0] = _createTextVNode(" Sender: CA-12 ", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" Date: " + _toDisplayString(_ctx.fullDate) + " ", 1),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" Subject: Monthly report " + _toDisplayString(_ctx.monthAndYearEnglish) + " - Customer inquiries to the Board of Management & Supervisory Board / Monatsreport " + _toDisplayString(_ctx.monthAndYearGerman) + " - Kundenanliegen Vorstand & ARV ", 1)
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _cache[6] || (_cache[6] = _createElementVNode("p", null, "Dear FIRST NAME,", -1)),
      _createElementVNode("p", null, " The following is the monthly report for " + _toDisplayString(_ctx.monthAndYearEnglish) + " on customer concerns addressed to the Board of Management & Supervisory Board of BMW AG worldwide. ", 1),
      _createElementVNode("div", { innerHTML: _ctx.englishContent }, null, 8, _hoisted_2),
      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
      _cache[8] || (_cache[8] = _createElementVNode("img", {
        src: _imports_1,
        alt: "example chart"
      }, null, -1)),
      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", { innerHTML: _ctx.englishSignature }, null, 8, _hoisted_3),
      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
      _cache[11] || (_cache[11] = _createElementVNode("p", null, "Guten Tag FIRST NAME,", -1)),
      _createElementVNode("p", null, " im Folgenden erhalten Sie das Monatsreporting " + _toDisplayString(_ctx.monthAndYearGerman) + " zu den Kundenanliegen, die weltweit an den Vorstand & ARV der BMW AG adressiert wurden. ", 1),
      _createElementVNode("div", { innerHTML: _ctx.germanContent }, null, 8, _hoisted_4),
      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
      _cache[13] || (_cache[13] = _createElementVNode("img", {
        src: _imports_1,
        alt: "example chart"
      }, null, -1)),
      _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", { innerHTML: _ctx.germanSignature }, null, 8, _hoisted_5)
    ])
  ]))
}